import { IRequesterInfo } from '../../../../../base/models'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { ISiteTimerModel } from '../models'

export class GetTimerApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/general/siteTimer',
      requesterInfo,
    })
  }

  public async getSiteTimer(): Promise<ISiteTimerModel[]> {
    return await this.getAsync<ISiteTimerModel[]>()
  }
}
